import { useEffect, useState } from "react";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";
import { FieldFilterType } from "../../../../base/types";

type ContactRecord = {
  contactid: string;
  mshied_currentacademicperiodid?: string;
};

export const useGetUserAcademicPeriod = () => {
  const { user, siteId } = useAuth();
  const [readContacts] = useLazyReadMultipleQuery();
  const [academicPeriodId, setAcademicPeriodId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchAcademicPeriod = async () => {
      if (!user?.contactId || !siteId) return;

      try {
        const result = await readContacts({
          userId: user?.contactId || '',
          portalId: siteId,
          tableId: "contact",
          fieldList: ["mshied_currentacademicperiodid"],
          filters: [
            {
              group: 0,
              filters: [
                { field: "contactid", type: FieldFilterType.Const, value: user.contactId },
              ],
            },
          ],
        }).unwrap();

        const contact = result.records?.[0] as ContactRecord | undefined;

        if (contact?.mshied_currentacademicperiodid) {
          setAcademicPeriodId(contact.mshied_currentacademicperiodid);
        } else {
          console.warn("No academic period linked to this contact.");
        }
      } catch (error) {
        console.error("Failed to fetch user's academic period:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAcademicPeriod();
  }, [user?.contactId, siteId, readContacts]);

  return { academicPeriodId, isLoading };
};
